const sites = {
    Kaigo: 'kaigo',
    Hoiku: 'hoiku',
    Kango: 'kango',
    Pos: 'pos',
    Gishi: 'gishi',
    Eiyoushi: 'eiyoushi',
    Dental: 'dental',
    Offer: 'offer',
}

const methods = {
    get value() {
        return process.env.SITE
    },
    isDefined() {
        return Object.values(sites).some((site) => site === this.value)
    },
    isKaigo() {
        return sites.Kaigo === this.value
    },
    isHoiku() {
        return sites.Hoiku === this.value
    },
    isKango() {
        return sites.Kango === this.value
    },
    isPos() {
        return sites.Pos === this.value
    },
    isGishi() {
        return sites.Gishi === this.value
    },
    isEiyoushi() {
        return sites.Eiyoushi === this.value
    },
    isDental() {
        return sites.Dental === this.value
    },
    isOffer() {
        return sites.Offer === this.value
    },
}

module.exports = new Proxy(methods, {
    get(target, prop) {
        if (prop in target) {
            return target[prop]
        } else {
            return sites[prop]
        }
    },
})
